import { createActions } from "redux-actions";

const {
  restoreLogin,
  restoreLoginSuccess,
  restoreLoginFailure,
  resetLogin,
  resetLoginSuccess,
} = createActions(
  "RESTORE_LOGIN",
  "RESTORE_LOGIN_SUCCESS",
  "RESTORE_LOGIN_FAILURE",
  "RESET_LOGIN",
  "RESET_LOGIN_SUCCESS",
  "RESET_LOGIN_FAILURE",
);

export { restoreLogin, restoreLoginSuccess, restoreLoginFailure, resetLogin, resetLoginSuccess };
